<app-modal-base [title]="dialogTitle" [hasSubmit]="false" [hasCancel]="false">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footerContent"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <ng-container *ngIf="!this.submitted; else submittedContent">
      <mat-stepper [linear]="true" #stepper (selectionChange)="stepperChanged($event)" [disableRipple]="true">
        <mat-step [stepControl]="addressStepControl" label="Informations">
          <ng-template matStepContent>
            <app-property-add-address [withAddressSearch]="true" [withAddressRequired]="true"
              (propertyCreated)="onPropertyCreated($event)" (propertyUpdated)="onPropertyUpdated($event)"
              [existingProp]="data.existingProp"></app-property-add-address>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </ng-template>
        </mat-step>
        <mat-step [stepControl]="mapStepControl" label="Localisation">
          <ng-template matStepContent>
            <app-property-add-location *ngIf="selectedIndex >= INDEX_ADD_LOCATION" [prop]="propertyUpdate"
              (propertyUpdated)="onPropertyUpdated($event)"></app-property-add-location>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Précédent</button>
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </ng-template>
        </mat-step>
        <mat-step [stepControl]="saleStepControl" label="Vente">
          <ng-template matStepContent>
            <app-property-add-sale *ngIf="selectedIndex >= INDEX_ADD_SALE" [prop]="propertyUpdate"
              [propSale]="propertySale" (propertySaleUpdated)="onPropertySaleUpdated($event)"
              (propertyUpdated)="onPropertyUpdated($event)"></app-property-add-sale>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Précédent</button>
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </ng-template>
        </mat-step>
        <mat-step [stepControl]="certifyStepControl" label="Validation">
          <ng-template matStepContent>
            <app-property-add-certify *ngIf="selectedIndex >= INDEX_ADD_CERTIFY" [prop]="propertyUpdate"
              (propertyUpdated)="onPropertyUpdated($event)"></app-property-add-certify>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Précédent</button>
              <!--<button mat-flat-button color="primary" matStepperNext>Suivant</button>-->
              <button mat-flat-button color="primary" (click)="submit()"
                [disabled]="propertyUpdate.deleted">Valider</button>
            </div>
          </ng-template>
        </mat-step>
      </mat-stepper></ng-container>
  </div>
</ng-template>

<ng-template #footerContent>
  <div [class]="'w-100 '+ (submitted ? 'text-center' : 'text-end')">
    <button mat-flat-button color="primary" [disabled]="submitInProgress" [mat-dialog-close]="createdPropId">{{submitted
      ?
      'Fermer' : 'Annuler'}}</button>
  </div>
</ng-template>

<ng-template #submittedContent>
  <div class="action-container">
    <div *ngIf="!data.existingProp" class="action" [ngSwitch]="stateCreateProperty">
      <mat-spinner *ngSwitchCase="'IN_PROGRESS'" diameter="20"></mat-spinner>
      <mat-icon *ngSwitchCase="'SUCCESS'" color="accent">done</mat-icon>
      <mat-icon *ngSwitchCase="'ERROR'" color="warn">error_outline</mat-icon>
      <span>Création du bien</span>
    </div>

    <div class="action" [ngSwitch]="stateUpdateProperty">
      <mat-spinner *ngSwitchCase="'IN_PROGRESS'" diameter="20"></mat-spinner>
      <mat-icon *ngSwitchCase="'SUCCESS'" color="accent">done</mat-icon>
      <mat-icon *ngSwitchCase="'ERROR'" color="warn">error_outline</mat-icon>
      <span>Mise à jour de la localisation</span>
    </div>

    <div class="action" *ngIf="managePropertySale" [ngSwitch]="stateUpdatePropertySale">
      <mat-spinner *ngSwitchCase="'IN_PROGRESS'" diameter="20"></mat-spinner>
      <mat-icon *ngSwitchCase="'SUCCESS'" color="accent">done</mat-icon>
      <mat-icon *ngSwitchCase="'ERROR'" color="warn">error_outline</mat-icon>
      <span>Mise à jour des informations de vente</span>
    </div>

    <div class="action" *ngIf="propertyUpdate.certified" [ngSwitch]="stateCertifyProperty">
      <mat-spinner *ngSwitchCase="'IN_PROGRESS'" diameter="20"></mat-spinner>
      <mat-icon *ngSwitchCase="'SUCCESS'" color="accent">done</mat-icon>
      <mat-icon *ngSwitchCase="'ERROR'" color="warn">error_outline</mat-icon>
      <span>Certification</span>
    </div>

    <div class="message" *ngIf="!propertyUpdate.certified && stateCertifyProperty==='SUCCESS'">
      <p>Votre bien est prêt à être configuré !</p>
    </div>
    <div class="message" *ngIf="propertyUpdate.certified && stateCertifyProperty==='SUCCESS'">
      <p>Votre bien est prêt à être partagé !</p>
      <p>Les données publiques sont en cours de récupération, vous serez notifié dés qu'elles seront disponibles.</p>
    </div>
  </div>


</ng-template>